var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-practice bg-white pr",
      attrs: { id: "practiceContainer" },
    },
    [
      _vm.info
        ? [
            _vm.currentQues
              ? _c("div", { staticClass: "yxtbiz-practice__title" }, [
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "span",
                      { staticClass: "yxtbiz-practice__title--left" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.generateQuesTitle(
                              _vm.currentQues.parent
                                ? _vm.currentQues.parent.quesType
                                : _vm.currentQues.quesType
                            )
                          )
                        ),
                        _c("span", { staticClass: "ml16" }, [
                          _vm._v(
                            _vm._s(
                              this.index + 1 + "/" + this.allQuestions.length
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm.canSkip
                      ? _c(
                          "span",
                          {
                            staticClass: "yxtbiz-practice__title--right",
                            on: { click: _vm.doSkip },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_skip")))]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm.currentQues
              ? _c(
                  "div",
                  { staticClass: "yxtbiz-practice__content" },
                  [
                    _c(
                      "yxt-scrollbar",
                      { attrs: { "fit-height": true } },
                      [
                        _vm.currentQues.parent
                          ? _c("user-pra-ques-detail", {
                              staticClass: "mv24 ph24",
                              attrs: {
                                practice: "",
                                value: _vm.currentQues.parent,
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "ph24" },
                          [
                            _c("user-pra-ques-detail", {
                              ref: "quesMain",
                              class: "mt24",
                              attrs: {
                                practice: "",
                                index: _vm.index,
                                allowUpload: 0,
                              },
                              on: { submitSingle: _vm.doSingle },
                              model: {
                                value: _vm.currentQues,
                                callback: function ($$v) {
                                  _vm.currentQues = $$v
                                },
                                expression: "currentQues",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "yxtbiz-practice__divider" },
                          [_c("yxtf-divider")],
                          1
                        ),
                        _vm.currentQues.isSubmited &&
                        _vm.info.allowViewSingleQuesResult
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-practice__result font-size-14 color-gray-9",
                              },
                              [
                                _vm.currentQues.quesType === 4 &&
                                _vm.currentQues.resultInfo.keywords &&
                                _vm.currentQues.resultInfo.keywords.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-practice__result-line",
                                      },
                                      [
                                        _c(
                                          "yxtf-tag",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-left",
                                            attrs: { size: "mini" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("pc_biz_ote_keyword")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-right",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.currentQues.resultInfo.keywords
                                                    .map(function (item) {
                                                      return item.name
                                                    })
                                                    .join(";")
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "yxtbiz-practice__result-line",
                                  },
                                  [
                                    _c(
                                      "yxtf-tag",
                                      {
                                        staticClass:
                                          "yxtbiz-practice__result-line-left",
                                        attrs: { size: "mini" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pc_biz_ote_lbl_submitanswer"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm.currentQues.quesType === 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-right",
                                          },
                                          [
                                            _vm._l(
                                              _vm.currentQues.ansUser,
                                              function (ans, fillIndex) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: "asw" + fillIndex,
                                                      staticClass:
                                                        "yxtbiz-practice-row-flex",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mr16" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              "(" +
                                                                (fillIndex +
                                                                  1) +
                                                                ") " +
                                                                ans.answer
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("yxt-svg", {
                                                        staticClass:
                                                          "yxtbiz-practice-row-flex__sub",
                                                        class: [
                                                          ans.corrected
                                                            ? "yxtf-color-success"
                                                            : "yxtf-color-danger",
                                                        ],
                                                        attrs: {
                                                          width: "16px",
                                                          height: "16px",
                                                          "remote-url":
                                                            _vm.mediaPath,
                                                          "icon-class":
                                                            ans.corrected
                                                              ? "success"
                                                              : "error",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-right yxtbiz-practice-row-flex",
                                          },
                                          [
                                            _vm.currentQues.quesType === 4
                                              ? _c("span", {
                                                  staticClass: "mr16",
                                                  attrs: {
                                                    "data-rich-text": "1",
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.currentQues.ansUser
                                                    ),
                                                  },
                                                })
                                              : _c(
                                                  "span",
                                                  { staticClass: "mr16" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentQues.ansUser
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            _c("yxt-svg", {
                                              staticClass:
                                                "yxtbiz-practice-row-flex__sub",
                                              class: [
                                                _vm.currentQues.resultInfo
                                                  .corrected
                                                  ? "yxtf-color-success"
                                                  : "yxtf-color-danger",
                                              ],
                                              attrs: {
                                                width: "16px",
                                                height: "16px",
                                                "remote-url": _vm.mediaPath,
                                                "icon-class": _vm.currentQues
                                                  .resultInfo.corrected
                                                  ? "success"
                                                  : "error",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                ),
                                _vm.info.allowViewSingleQuesAnswer
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-practice__result-line",
                                      },
                                      [
                                        _c(
                                          "yxtf-tag",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-left",
                                            attrs: {
                                              type: "warning",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_lbl_trueanswer"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm.currentQues.quesType === 3
                                          ? _c(
                                              "div",
                                              [
                                                _vm.currentQues.ansCorrect
                                                  .length
                                                  ? [
                                                      _vm._l(
                                                        _vm.currentQues
                                                          .ansCorrect,
                                                        function (
                                                          ans,
                                                          fillIndex
                                                        ) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "asw" +
                                                                  fillIndex,
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    (" +
                                                                    _vm._s(
                                                                      fillIndex +
                                                                        1
                                                                    ) +
                                                                    ") " +
                                                                    _vm._s(
                                                                      ans
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        }
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pc_biz_ote_lbl_none"
                                                          )
                                                        )
                                                      ),
                                                    ],
                                              ],
                                              2
                                            )
                                          : _vm.currentQues.quesType === 4
                                          ? _c(
                                              "div",
                                              [
                                                _vm.currentQues.ansCorrect ||
                                                _vm.currentQues.resultInfo
                                                  .answerPlay
                                                  ? [
                                                      _vm.cleanStyle(
                                                        _vm.currentQues
                                                          .ansCorrect
                                                      )
                                                        ? _c("div", {
                                                            staticClass:
                                                              "yxtbiz-practice__result-line-right",
                                                            attrs: {
                                                              "data-rich-text":
                                                                "1",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.cleanStyle(
                                                                  _vm
                                                                    .currentQues
                                                                    .ansCorrect
                                                                )
                                                              ),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.currentQues.resultInfo
                                                        .answerPlay &&
                                                      _vm.currentQues.resultInfo
                                                        .answerPlay.fileId
                                                        ? _c("media-player", {
                                                            key: _vm.currentQues
                                                              .resultInfo
                                                              .answerPlay
                                                              .fileId,
                                                            attrs: {
                                                              type: _vm
                                                                .currentQues
                                                                .resultInfo
                                                                .answerPlay
                                                                .type,
                                                              options:
                                                                _vm.playerMediaOptions(
                                                                  _vm
                                                                    .currentQues
                                                                    .resultInfo
                                                                    .answerPlay
                                                                ),
                                                              tranStatus:
                                                                _vm.currentQues
                                                                  .resultInfo
                                                                  .answerPlay
                                                                  .tranStatus,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pc_biz_ote_lbl_none"
                                                          )
                                                        )
                                                      ),
                                                    ],
                                              ],
                                              2
                                            )
                                          : _c("div", {
                                              staticClass:
                                                "yxtbiz-practice__result-line-right",
                                              attrs: { "data-rich-text": "1" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.cleanStyle(
                                                    _vm.currentQues
                                                      .ansCorrect ||
                                                      _vm.$t(
                                                        "pc_biz_ote_lbl_none"
                                                      )
                                                  )
                                                ),
                                              },
                                            }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.info.allowViewSingleQuesExplain
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-practice__result-line",
                                      },
                                      [
                                        _c(
                                          "yxtf-tag",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-left",
                                            attrs: { size: "mini" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_lbl_quesdesc"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "yxtbiz-practice__result-line-right",
                                          },
                                          [
                                            _c("span", {
                                              attrs: { "data-rich-text": "1" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.cleanStyle(
                                                    _vm.currentQues.resultInfo
                                                      .explainText
                                                  ) ||
                                                    (!_vm.currentQues.resultInfo
                                                      .explainPlay
                                                      ? _vm.$t(
                                                          "pc_biz_ote_lbl_none"
                                                        )
                                                      : "")
                                                ),
                                              },
                                            }),
                                            _vm.currentQues.resultInfo
                                              .explainPlay &&
                                            _vm.currentQues.resultInfo
                                              .explainPlay.fileId
                                              ? _c("media-player", {
                                                  key: _vm.currentQues
                                                    .resultInfo.explainPlay
                                                    .fileId,
                                                  attrs: {
                                                    type: _vm.currentQues
                                                      .resultInfo.explainPlay
                                                      .type,
                                                    options:
                                                      _vm.playerMediaOptions(
                                                        _vm.currentQues
                                                          .resultInfo
                                                          .explainPlay
                                                      ),
                                                    tranStatus:
                                                      _vm.currentQues.resultInfo
                                                        .explainPlay.tranStatus,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "yxtbiz-practice__btns--confirm" },
                          [
                            !_vm.currentQues.isSubmited &&
                            _vm.currentQues.quesType !== 0 &&
                            _vm.currentQues.quesType !== 2
                              ? _c(
                                  "yxtf-button",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.isAnswered || _vm.isSubmiting,
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.doSingle(
                                          _vm.currentQues,
                                          true
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t("pc_biz_ote_btn_confirm")
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "yxtbiz-practice__btns" },
              [
                _c(
                  "yxtf-button",
                  {
                    attrs: {
                      plain: "",
                      size: "larger",
                      disabled: _vm.index <= 0 || _vm.isSubmiting,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goIndex(-1)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("pc_biz_ote_btn_prevques")) +
                        "\n      "
                    ),
                  ]
                ),
                _c(
                  "yxtf-button",
                  {
                    attrs: {
                      plain: !_vm.isLastQues,
                      size: "larger",
                      type: _vm.isLastQues ? "primary" : "",
                      disabled:
                        _vm.isSubmiting ||
                        !_vm.currentQues.isSubmited ||
                        (_vm.isConfirmed && _vm.isLastQues),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goIndex(1)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            _vm.isLastQues
                              ? "pc_biz_ote_btn_submit"
                              : "pc_biz_ote_btn_nextques"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.showWatermark
              ? _c("yxtbiz-watermark", {
                  attrs: { option: _vm.watermarkConfig, show: true },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }